module.exports = __webpack_public_path__ + "static/sch-slide1-d002631d138c99c09ee7b5216bea6b6a.png";